import React from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

import { normalizeMarkdownContent } from '@ping/helpers/markdown-content.helper';

import style from './markdown-content.module.scss';

export type MarkdownContentVariant = 'default' | 'compact' | 'legal';

interface IMarkdownContentProps {
  content: string;
  className?: string;
  variant?: MarkdownContentVariant;
}

const markdownLink = ({
  href,
  children,
  ...props
}: {
  href?: string;
  children?: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a href={href} target='_blank' rel='noopener noreferrer' {...props}>
    {children}
  </a>
);

export const MarkdownContent = ({ content, className, variant = 'default' }: IMarkdownContentProps) => {
  const variantClass = variant === 'compact' ? style['compact'] : variant === 'legal' ? style['legal'] : '';
  const rootClass = [style['markdown'], variantClass, className].filter(Boolean).join(' ');
  const normalizedContent = normalizeMarkdownContent(content);

  return (
    <div className={rootClass}>
      <Markdown remarkPlugins={[remarkGfm, remarkBreaks]} components={{ a: markdownLink }}>
        {normalizedContent}
      </Markdown>
    </div>
  );
};
